<template>
  <Card
    dis-hover
    shadow
  >
    <div slot="title">
      <Button
        type="primary"
        :to="{ name: 'login-number-inside' }"
      >
        <b>返回</b>
      </Button>
    </div>
    <div>
      <h2 class="mb-2">新增内页</h2>
      <Form
        ref="formCustom"
        :model="formCustom"
        :rules="ruleCustom"
        label-position="top"
        style="max-width: 300px;width: auto;"
      >
        <!-- <FormItem label="登入页编号" prop="setlineId">
          <Input type="number" v-model="formCustom.setlineId" size="default" disabled></Input>
        </FormItem> -->
        <FormItem
          label="导向网址"
          prop="InsideUrl"
        >
          <Input
            type="text"
            v-model="formCustom.InsideUrl"
            size="default"
          ></Input>
        </FormItem>
        <FormItem label="类别">
          <Select
            v-model="formCustom.class"
            size="default"
          >
            <Option
              v-for="it in select"
              :key="it.key"
              :value="it.key"
            >{{it.name}}</Option>
          </Select>
        </FormItem>
        <FormItem label="状态">
          <RadioGroup v-model="formCustom.status">
            <Radio
              class="mx-5 px-2"
              :label="1"
              border
            >啟用</Radio>
            <Radio
              class="mx-5 px-2"
              :label="0"
              border
            >停用</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem>
          <Button
            type="primary"
            @click="handleSubmit('formCustom')"
          >新增</Button>
          <Button
            @click="handleReset('formCustom')"
            style="margin-left: 8px"
          >重置</Button>
        </FormItem>
      </Form>
    </div>
  </Card>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  name: 'add-login-number-inside',
  data () {
    return {
      select: [
        // { name: "未分类", key: 0 },
        // { name: "总公司", key: 1 },
        { name: "代理", key: 2 },
        { name: "会员", key: 3 }
      ],
      formCustom: {
        setlineId: this.$route.params.id,
        InsideUrl: '',
        class: '',
        status: 1
      },
      ruleCustom: {
        // setlineId: [
        //   { required: true, message: "请勿留空", trigger: 'blur' },
        //   { type: 'string', message: "格式错误", trigger: 'blur' },
        // ],
        InsideUrl: [
          { required: true, message: "请勿留空", trigger: 'blur' },
          { type: 'string', message: "格式错误", trigger: 'blur' },
        ]
      }
    }
  },
  computed: {
    ...mapGetters(['getmember'])
  },
  methods: {
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) this.setlineInsideAdd()
      })
    },
    handleReset (name) {
      this.$refs[name].resetFields();
    },
    async setlineInsideAdd () {
      try {
        const obj = {
          ...this.formCustom,
          setlineId: Number(this.formCustom.setlineId),
          loid: this.getmember.pid
        }
        const res = await this.$axios.websiteManagement.setlineInsideAdd(obj)
        if (res.status == 1) {
          this.$Message.success('新增成功');
          this.$router.push({ name: 'login-number-inside' })
        }
      } catch (error) {
        console.log(error);
      }
    },
  }
}
</script>